import * as React from 'react'

export const ResultsBlockCSV = (props: any): JSX.Element => {
    return (
        <div className="uploads-csv-results-block">
            <h2 className="csv-results-title">Resultados:</h2>
            {props.timeUploadInfo !== '' ? <h4 className="csv-results-info">{props.timeUploadInfo}</h4> : null}
            {props.registeredItems && props.registeredItems.countScanned && props.registeredItems.countScanned > 0 ? (
                <h3 className="csv-results-info">
                    <strong>Items revisados: </strong>
                    {props.registeredItems.countScanned}
                </h3>
            ) : null}
            {props.timeScanInfo !== '' ? <h4 className="csv-results-info">{props.timeScanInfo}</h4> : null}
            {props.registeredItems && props.registeredItems.countAdded && props.registeredItems.countAdded > 0 ? (
                <h3 className="csv-results-info">
                    <strong>Items añadidos: </strong>
                    {props.registeredItems.countAdded}
                </h3>
            ) : null}
            {props.timeWriteInfo !== '' ? <h4 className="csv-results-info">{props.timeWriteInfo}</h4> : null}
            {props.registeredItems && props.registeredItems.countProblems && props.registeredItems.countProblems > 0 ? (
                <React.Fragment>
                    <h3 className="csv-results-info">
                        <strong>Filas con problemas: </strong>
                        {props.registeredItems.countProblems}
                    </h3>
                </React.Fragment>
            ) : null}
            {(props.registeredItems.countScanned && props.registeredItems.countAdded) ||
                (props.registeredItems && props.registeredItems.countProblems) ? (
                    <React.Fragment>
                        <h4 className="csv-results-info">
                            <strong>Revisados menos añadidos y errores: </strong>
                            {props.registeredItems.countAdded +
                                props.registeredItems.countProblems -
                                props.registeredItems.countScanned}
                        </h4>
                    </React.Fragment>
                ) : null}
        </div>
    )
}